import dispatcher from "../Dispatcher";
import * as Globals from "../Globals";
import axios from "axios";
import actionTypes from "./ActionTypes";
import { login, logout, loginFail } from "../state/loginInfoSlice";
import { GetUserFieldSettings } from "./UserSettingActions";
export function CheckTDVersion() {
  axios.get(
    `${Globals.baseUrl}/Login/GetTDVersion`,
    {
      headers: { "content-type": "application/json; charset=utf-8" }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.LoginCheckVer,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoginViaTd6Token(token, dispatch) {
  axios.post(
    `${Globals.baseUrl}/Login/LogInViaTd6Token`,
    { TokenValue: token },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        "Access-Control-Allow-Origin": "*"
      },
      withCredentials: true
    }
  ).then((res) => {
    if (res.status === 200 && res.data.isLoggedIn === true) {
      dispatch(login(res.data));
      dispatcher.dispatch({
        actionType: actionTypes.Login_Silent,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoginViaMSOAuth(azureToken) {
  axios.get(`${Globals.baseUrl}/Login/LogInViaMSOauth/${azureToken}`, {
    headers: { "content-type": "application/json; charset=utf-8" }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.Login_Silent,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoginViaMSOAuth2(azureToken, dispatch) {
  axios.get(`${Globals.baseUrl}/Login/LogInViaMSOauth/${azureToken}`, {
    headers: { "content-type": "application/json; charset=utf-8" }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(login(res.data));
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  });
}
export function LoginViaUserIdPwd(userId, password, dispatch) {
  axios.post(
    `${Globals.baseUrl}/Login/LogInViaUserIdPwd`,
    { UserId: userId, Password: password },
    {
      headers: { "content-type": "application/json; charset=utf-8" },
      withCredentials: true
    }
  ).then((res) => {
    if (res.status === 200) {
      if (res.data.isLoggedIn) {
        dispatch(login(res.data));
        dispatcher.dispatch({
          actionType: actionTypes.Login_Silent,
          Result: res.data
        });
      } else {
        dispatch(loginFail(res.data));
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
    dispatch(loginFail({
      isLoggedIn: false,
      jwtToken: "",
      message: "Unable to reach server",
      userFullName: "",
      userId: 0,
      userName: ""
    }));
  });
}
export function Logout(dispatch) {
  axios.get(`${Globals.baseUrl}/Login/Logout`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`,
      withCredentials: true
    }
  }).then((res) => {
    if (dispatch !== void 0) {
      dispatch(logout());
    } else {
      console.log("click out");
      let lobutton = document.getElementById("logOutBtn");
      lobutton.click();
    }
  });
}
export function CanUserWebUpload() {
  console.log("can user web upload?");
  axios.get(`${Globals.baseUrl}/Login/CanUserWebUpload`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CanUserWebUpload,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoginViaMicrosoft() {
  console.log("Login via Microsoft");
  console.log("sign in");
  axios.post(`${Globals.baseUrl}/Login/LoginViaMicrosoft`, null, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      window.location.href = res.data.address;
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function LoginViaTDMicrosoft() {
  console.log("Login via Microsoft");
  console.log("sign in");
  axios.post(`${Globals.baseUrl}/Login/LoginViaTDMicrosoft`, null, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      window.location.href = res.data.address;
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
